import { accountExceptions } from "./accountExceptions.ts";
import { docvaultExceptions } from "./docvaultExceptions.ts";
import { verificationExceptions } from "../default/verificationExceptions.ts";

export const allExceptions: any = {
  ...accountExceptions,
  ...docvaultExceptions,
  ...verificationExceptions,
};
